// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-text {
  color: green;
  font-weight: bold;
}

.clickable-navigation-text {
  cursor: pointer;
}

.active-navigation-text {
  font-weight: bold;
  text-decoration: underline;
}

.disabled-navigation-text {
  color: gray;
}

.col {
  display: flex;
  text-align: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/navigation-tabs/navigation-tabs.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,iBAAA;EACA,0BAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;AACF","sourcesContent":[".navigation-text {\r\n  color: green;\r\n  font-weight: bold;\r\n}\r\n\r\n.clickable-navigation-text {\r\n  cursor: pointer;\r\n}\r\n\r\n.active-navigation-text {\r\n  font-weight: bold;\r\n  text-decoration: underline;\r\n}\r\n\r\n.disabled-navigation-text {\r\n  color: gray;\r\n}\r\n\r\n.col{\r\n  display: flex;\r\n  text-align: center;\r\n  justify-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
